export type AccountSectionKey = 'wishlist' | 'myData' | 'orders' | 'reviews' | 'discounts' | 'bonuses';

export const getTierName = (tier: string): string => {
    const names: Record<string, string> = {
        base: 'бронзовый',
        silver: 'серебряный',
        gold: 'золотой',
        platinum: 'VIP',
    };
    return Object.prototype.hasOwnProperty.call(names, tier) ? names[tier] : tier || '';
};

export const getBonusWord = (num: number) => {
    const n = Math.abs(Number(num) || 0);
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11) return 'балл';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'балла';
    return 'баллов';
};

export const formatMoney = (n: number | undefined | null) => {
    if (n == null) return '—';
    const v = Number(n);
    if (!Number.isFinite(v)) return '—';
    try {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            maximumFractionDigits: 0,
        }).format(v);
    } catch {
        return `${Math.round(v)} ₽`;
    }
};

export const formatDateTimeRu = (iso?: string | number | null) => {
    if (iso == null) return '—';
    const d = typeof iso === 'number' ? new Date(iso) : new Date(String(iso));
    if (Number.isNaN(d.getTime())) return '—';
    try {
        return new Intl.DateTimeFormat('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(d);
    } catch {
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yy = d.getFullYear();
        const hh = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${dd}.${mm}.${yy}, ${hh}:${min}`;
    }
};

export const PAYMENT_STATUS_RU: Record<string, string> = {
    pending: 'в ожидании',
    waiting_for_capture: 'на подтверждении',
    succeeded: 'оплачен',
    paid: 'оплачен',
    canceled: 'отменён',
    cancelled: 'отменён',
    refunded: 'возврат',
    failed: 'ошибка',
};

export const paymentStatusToRu = (s?: string | null) => {
    const k = String(s ?? '').toLowerCase();
    return PAYMENT_STATUS_RU[k] ?? (k ? k : '—');
};

export const DPD_STATUS_RU: Record<string, string> = {
    OK: 'создан',
    ORDERPENDING: 'принят в обработку',
    ACCEPTED: 'принят',
    INPROCESS: 'в обработке',
    INPROGRESS: 'в обработке',
    CREATED: 'создан',
    CANCELED: 'отменён',
    CANCELLED: 'отменён',
    CANCELEDPREVIOUSLY: 'уже отменён',
    ERROR: 'ошибка',
};

export const dpdStatusToRu = (s?: string | null) => {
    const k = String(s ?? '')
        .trim()
        .toUpperCase();
    return DPD_STATUS_RU[k] ?? (k || '—');
};

export const normalizeServerUrl = (serverUrl?: string) => String(serverUrl || '').replace(/\/+$/, '');

export const isDpdDelivery = (deliveryMethod?: string | null) =>
    String(deliveryMethod || '')
        .trim()
        .toLowerCase() === 'dpd';

export const safeOrderId = (o: any): string | null => {
    const raw = o?.id ?? o?._id;
    if (!raw) return null;
    return typeof raw === 'string' ? raw : String(raw);
};

export const safeOrderNumber = (o: any): string => String(o?.orderNumber ?? '—');
